module.exports = __webpack_public_path__ + "img/5.53de8743.jpg";